import React from 'react';
import { motion } from 'framer-motion';

export default function MaterialStory() {
  return (
    <section className="py-32 bg-creamDark relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="aspect-[4/5] overflow-hidden shadow-2xl border-[12px] border-white">
              <img 
                src="https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&q=80&w=800" 
                alt="Leather texture and craftsmanship" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-brass/10 rounded-full blur-3xl -z-10"></div>
            {/* Overlay Detail */}
            <div className="absolute -left-8 top-1/2 -translate-y-1/2 bg-saddle p-8 text-cream hidden md:block shadow-2xl">
              <span className="font-serif text-3xl block mb-2 italic">Since 2018</span>
              <span className="font-sans text-[10px] uppercase tracking-[0.3em]">Built for life</span>
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="lg:pl-12 text-center lg:text-left"
          >
            <h4 className="font-sans text-[11px] tracking-[0.4em] uppercase text-saddle mb-6 font-bold">The Workshop Standard</h4>
            <h2 className="font-serif text-5xl md:text-6xl text-navy mb-8 leading-[1.1]">Materials That Speak</h2>
            <div className="w-16 h-1 bg-brass mb-10 mx-auto lg:mx-0"></div>
            <p className="font-sans text-navy/70 mb-8 leading-relaxed text-lg">
              We source only the finest full-grain, vegetable-tanned leather from historic tanneries. Unlike mass-market goods, our leather isn't sanded or chemically altered—it retains its natural marks, strength, and soul.
            </p>
            <p className="font-sans text-navy/70 mb-12 leading-relaxed">
              Paired with solid brass hardware that develops a unique patina alongside the leather, and stitched with heavy-duty bonded nylon thread, every piece is a testament to the slow-craft movement.
            </p>
            <div className="grid grid-cols-3 gap-8 border-t border-navy/10 pt-10">
              <div className="text-center lg:text-left">
                <span className="block font-serif text-3xl text-saddle mb-2 tracking-tighter">100%</span>
                <span className="font-sans text-[9px] uppercase tracking-[0.2em] text-navy/50 font-bold">Full Grain</span>
              </div>
              <div className="text-center lg:text-left border-x border-navy/10 px-4">
                <span className="block font-serif text-3xl text-saddle mb-2 tracking-tighter">Solid</span>
                <span className="font-sans text-[9px] uppercase tracking-[0.2em] text-navy/50 font-bold">Brass</span>
              </div>
              <div className="text-center lg:text-left">
                <span className="block font-serif text-3xl text-saddle mb-2 tracking-tighter">Life</span>
                <span className="font-sans text-[9px] uppercase tracking-[0.2em] text-navy/50 font-bold">Warranty</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}